module.exports = __webpack_public_path__ + "static/media/PDF10.1383a32f.pdf";